<div class="right-side p-5">

  <form [formGroup]="verifyMSME">
    <div class="section">
      <div class="card mb-3">
        <div class="card-header"><h2>Personal Details</h2></div>
        <div class="card-body">

          <div class="row mb-3">
            <div class="col-md-4">
              <label>UDYAM Number</label>
              <input type="text" class="form-control" formControlName="udyamRegistrationNumber">
            </div>
            <div class="col-md-4">
              <label>Name</label>
              <input type="text" class="form-control" formControlName="name">
            </div>
            <div class="col-md-4">
              <label>Gender</label>
              <input type="text" class="form-control" formControlName="gender">
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-4">
              <label>Email</label>
              <input type="text" class="form-control" formControlName="email">
            </div>
            <div class="col-md-4">
              <label>Are you a person with Disabilities?</label>
              <input type="text" class="form-control" formControlName="areYouAPersonWithDisabilities">
            </div>
            <div class="col-md-4">
              <label>Owner's Mobile Number</label>
              <input type="text" class="form-control" formControlName="ownersMobileNumber">
              <div>
                <label for="chkboxwhatsappenabled">Is WhatsApp Enabled?</label>
                <input type="checkbox" formControlName="isWhatsAppEnabled" />
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-4">
              <label>Alternate Contact Number</label>
              <input type="text" class="form-control" formControlName="alternateContactNumber">
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header"><h2>Enterprise Details</h2></div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-4">
              <label>Name of Enterprise</label>
              <input type="text" class="form-control" formControlName="nameOfEnterprise">
            </div>
            <div class="col-md-4">
              <label>Type of Organization</label>
              <input type="text" class="form-control" formControlName="typeOfOrganization">
            </div>
            <div class="col-md-4">
              <label>Type of Enterprise</label>
              <input type="text" class="form-control" formControlName="typeOfEnterprise">
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-4">
              <label>Official Address of Enterprise</label>
              <input type="text" class="form-control" formControlName="officialAddressOfEnterprise">
            </div>
            <div class="col-md-4">
              <label>State</label>
              <input type="text" class="form-control" formControlName="stateName">
            </div>
            <div class="col-md-4">
              <label>District</label>
              <input type="text" class="form-control" formControlName="districtName">
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-4">
              <label>Block</label>
              <input type="text" class="form-control" formControlName="block">
            </div>
            <div class="col-md-4">
              <label>City</label>
              <input type="text" class="form-control" formControlName="city">
            </div>
            <div class="col-md-4">
              <label>Pin</label>
              <input type="text" class="form-control" formControlName="pin">
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-4">
              <label>DIC</label>
              <input type="text" class="form-control" formControlName="dic">
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-4">
              <label>Date of Commencement</label>
              <input type="text" class="form-control" formControlName="dateOfCommencement">
            </div>
            <div class="col-md-4">
              <label>Date of Incorporation</label>
              <input type="text" class="form-control" formControlName="dateOfIncorporation">
            </div>
            <div class="col-md-4">
              <label>Major Activity</label>
              <input type="text" class="form-control" formControlName="majorActivity">
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-4">
              <label>Investment Cost</label>
              <input type="text" class="form-control" formControlName="investmentCost">
            </div>
          </div>

          <!--<div class="row mb-3">
            <div class="col-md-4">
              <label>Are you an Exporter ?</label>
              <input type="text" class="form-control" formControlName="areYouAnExporter">
            </div>
            <div class="col-md-4">
              <label>IEC</label>
              <input type="text" class="form-control" formControlName="iec">
            </div>

          </div>-->
        </div>
      </div>





      <div class="card mb-3">
        <div class="card-header"> <h2>NIC Details</h2></div>
        <div class="card-body">
          <!-- NIC Details Table -->
          <div class="row">
            <div class="table-responsive">

              <table class="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th class="text-center">Sr. No.</th>
                    <th class="text-center">NIC Code</th>
                    <th class="text-center">Sector Code</th>
                    <th class="text-center">Sector</th>
                    <th class="text-center">Division</th>
                    <th class="text-center">Group</th>
                    <th class="text-center">Class</th>
                    <th class="text-center">Sub Class</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Check if nicdata exists and has items -->
                  <ng-container *ngIf="nicdata && nicdata.length > 0; else noNICData">
                    <tr *ngFor="let nic of nicdata; let i = index">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-center">{{ nic.nicCode }}</td>
                      <td class="text-center">{{ nic.sectorCode }}</td>
                      <td class="text-center">{{ nic.sectorName }}</td>
                      <td class="text-center">{{ nic.divisionName }}</td>
                      <td class="text-center">{{ nic.groupName }}</td>
                      <td class="text-center">{{ nic.className }}</td>
                      <td class="text-center">{{ nic.subClassName }}</td>
                    </tr>
                  </ng-container>
                  <!-- No Data Found -->
                  <ng-template #noNICData>
                    <tr>
                      <td colspan="9" class="text-center">No Data Found</td>
                    </tr>
                  </ng-template>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>


      <div class="card mb-3">
        <div class="card-header"> <h2>Plant Details</h2></div>
        <div class="card-body">

          <!-- Plant Details Table -->
          <div class="row">
            <div class="table-responsive">

              <table class="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th class="text-center">Plant Name</th>
                    <th class="text-center">Plant Location</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Check if plandata exists and has items -->
                  <ng-container *ngIf="plandata && plandata.length > 0; else noPlantData">
                    <tr *ngFor="let plant of plandata">
                      <td class="text-center">{{ plant.plantName }}</td>
                      <td class="text-center">{{ plant.plantLocation }}</td>
                    </tr>
                  </ng-container>
                  <!-- No Data Found -->
                  <ng-template #noPlantData>
                    <tr>
                      <td colspan="2" class="text-center">N/A</td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-header"> <h2>Interests</h2></div>
        <div class="card-body">
          <!-- Interests Table -->
          <div class="row">
            <div class="table-responsive">

              <table class="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th class="text-center">Interest Name</th>
                    <th class="text-center">Intervention Name</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Check if interestdata exists and has items -->
                  <ng-container *ngIf="interestdata && interestdata.length > 0; else noData">
                    <tr *ngFor="let interest of interestdata">
                      <td class="text-center">{{ interest.interestName }}</td>
                      <td class="text-center">{{ interest.interventionName }}</td>
                    </tr>
                  </ng-container>
                  <!-- No Data Found -->
                  <ng-template #noData>
                    <tr>
                      <td colspan="2" class="text-center">No Data Found</td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    
      <div class="card mb-3">
        <div class="card-header"><h2>Uploaded Documents</h2></div>
        <div class="card-body">
          <!-- File Details -->

          <div class="table-responsive">
            <table class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th class="text-center">Document Type</th>
                  <th class="text-center">Document Name</th>
                  <th class="text-center">Download</th>
                </tr>
              </thead>
              <tbody>
                <!-- Check if filedata exists and has items -->
                <ng-container *ngIf="filedata && filedata.length > 0; else noData">
                  <tr *ngFor="let file of filedata">
                    <td class="text-center">{{ file.documentType }}</td>
                    <td class="text-center">{{ file.documentName }}</td>
                    <td class="text-center">
                      <a *ngIf="file.documentPath"
                         (click)="onDownload(file.documentPath, file.documentName); $event.preventDefault()" class="btn btn-warning btn-sm mt-1">
                        <i class="bi bi-download"></i> Download
                      </a>
                      <button class="btn btn-primary btn-sm mt-1 mx-1" (click)="openFilePreviewDialog(file.documentPath, file.documentName)"> <i class="bi bi-eye"></i> View File</button>
                    </td>
                  </tr>
                </ng-container>
                <!-- No Data Found -->
                <ng-template #noData>
                  <tr>
                    <td colspan="3" class="text-center">No Data Found</td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>

          <hr />

          <div class="row mb-3">
            <div class="col-md-3">
              <label for="statusSelect">Select Status<span class="text-danger">*</span></label>
              <select class="form-select" formControlName="status" [disabled]="action">
                <option value="">--select status--</option>
                <option *ngFor="let option of status" [value]="option.id">
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div><br />

          <div class="row mb-3">
            <div class="col-md-6">
              <label for="remarks">Remarks<span *ngIf="showAsterisk" class="text-danger">*</span></label>
              <textarea id="textarea" formControlName="remarks" rows="4" cols="80" maxlength="200" class="form-control"></textarea>
              <div *ngIf="verifyMSME.get('remarks')?.invalid" class="error">
                <div *ngIf="verifyMSME.get('remarks')?.errors?.['required']" class="error">Remarks is required.</div>
                <div *ngIf="verifyMSME.get('remarks')?.errors?.['maxlength']">
                  Remarks cannot exceed 200 characters.
                </div>
              </div>
              <br />
              <button id="btnsave" type="submit" (click)="ViewStatusHistory()" class="btn btn-primary me-2">View Status History</button>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-4">
              <button *ngIf="action" class="btn btn-success" (click)="submit()">Submit</button>
              <button *ngIf="action" class="btn btn-danger mx-2" (click)="cancel()">Cancel</button>
              <button class="btn btn-info" (click)="back()">Back</button>
            </div>

          </div>
        </div>
      </div>

     


    </div>

  </form>

</div>
